<template lang="">
    <div class="flex flex-col gap-y-6">
        <Input type="text" iconName="Pesquisar" placeholder="Faça sua pesquisa aqui" v-model="searchValue"/>
        <div class="flex flex-col gap-y-6">
            <label v-if="filteredOptions?.length" v-for="option in filteredOptions" :key="option.id" class="p-4 hover:bg-gray-100 rounded-2xl cursor-pointer" >
                <div class="flex flex-col gap-y-6">
                    <div class="flex gap-x-2">
                        <input type="radio" v-model="optionsSelected" :value="option">
                        {{option.name}}
                    </div>
                    <img v-if="option.imageUrl" :src="option.imageUrl" class="w-[348px] h-[auto] max-h-[332.45px] border rounded-2xl object-contain">
                </div>
            </label>
            <label v-else class="text-center text-lg text-[#808080]">
                Não encontramos nenhum resultado para o termo digitado
            </label>
        </div>
    </div>
</template>
<script>
import Input from "@/Components/UI/Form/Input.vue"

export default {
    emits: ['updateValue'],
    components: {
        Input,
    },
    props: {
        options: Array,
        modelValue: Array,
        initialValue: Object,
    },
    data() {
        return {
            searchValue: '',
            optionsSelected: this.initialValue,
        }
    },
    computed: {
        filteredOptions() {
            return this.options.filter(
                (option) =>
                    option?.name
                        .toLowerCase()
                        .indexOf(this.searchValue.toLowerCase()) > -1
            );
        },
    }, 
    watch: {
        initialValue: {
            handler(newValue) {
                this.optionsSelected = newValue;
            },
        },
        optionsSelected: {
            handler(newValue) {
                this.$emit("updateValue", newValue);
                console.log({ newValue })
            }
        }
    }

    
}
</script>
<style lang="">
    
</style>